import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useNavigate } from '@rocketlane/rocket-router';
import { Result } from 'antd';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Loading } from 'components/atoms/loading';
import { useCreateCustomerApiKey } from 'hooks/use-create-customer-api-key';
import { useQueryParamsFromWindow } from 'hooks/use-query-params';
import { API_KEY, logger } from 'services';
import { decodeJWT } from 'utils/http-utilts';
const redirect = (url)=>{
    window.location.href = url;
};
export const CustomerPortalMagicLink = ()=>{
    const queryParams = useQueryParamsFromWindow();
    const router = useNavigate();
    const { mutateAsync } = useCreateCustomerApiKey();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(()=>{
        const token = queryParams.get('token');
        const apiKeyStr = localStorage.getItem(API_KEY);
        let route = '/';
        let inviteIfAbsent = false;
        try {
            var _ref;
            var _payload_config, _payload_config1, _payload_config2;
            const { payload } = decodeJWT(token);
            if (payload === null || payload === void 0 ? void 0 : (_payload_config = payload.config) === null || _payload_config === void 0 ? void 0 : _payload_config.hashParam) {
                const { hashParam } = payload.config;
                const decodedHashParam = decodeURIComponent(hashParam[0] === '#' ? hashParam.substring(1) : hashParam);
                const params = new URLSearchParams(decodedHashParam);
                const kvParams = Object.fromEntries(params.entries());
                if (kvParams === null || kvParams === void 0 ? void 0 : kvParams.route) {
                    route += kvParams.route;
                }
            }
            if (payload === null || payload === void 0 ? void 0 : (_payload_config1 = payload.config) === null || _payload_config1 === void 0 ? void 0 : _payload_config1.projectId) {
                localStorage.setItem('ppi', payload.config.projectId);
            }
            inviteIfAbsent = (_ref = payload === null || payload === void 0 ? void 0 : (_payload_config2 = payload.config) === null || _payload_config2 === void 0 ? void 0 : _payload_config2.inviteIfAbsent) !== null && _ref !== void 0 ? _ref : false;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (err) {
        // pass
        }
        if (apiKeyStr != null && !inviteIfAbsent) {
            try {
                const apiKeyArr = JSON.parse(apiKeyStr);
                const apiKey = apiKeyArr === null || apiKeyArr === void 0 ? void 0 : apiKeyArr.at(1);
                if (apiKey) {
                    router(route === '' ? '/' : route !== null && route !== void 0 ? route : '/');
                    return;
                }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            } catch (err) {
            // pass
            }
        } else if (apiKeyStr == null) {
            logger.debug("API key doesn't exist in local storage");
        }
        mutateAsync({
            jwt: token
        }, {
            onSuccess: (data)=>{
                var _data_createdBy;
                logger.debug('fetched api key for access token');
                localStorage.setItem(API_KEY, `["api_key", "${data === null || data === void 0 ? void 0 : data.apiKey}", ${data === null || data === void 0 ? void 0 : (_data_createdBy = data.createdBy) === null || _data_createdBy === void 0 ? void 0 : _data_createdBy.userId}, ${data === null || data === void 0 ? void 0 : data.apiKeyId}]`);
                localStorage.setItem('customer_portal', 'true');
                setLoading(false);
                setError(false);
                // Reload to the JWT-decoded destination instead of the current URL
                // so the token query param is dropped — otherwise inviteIfAbsent=true
                // would re-trigger the invite on every reload (infinite loop).
                // Full page reload is retained so the auth flow boots cleanly.
                redirect(`${window.location.origin}${route}`);
            },
            onError: (_error)=>{
                setLoading(false);
                setError(true);
            }
        });
    }, [
        mutateAsync,
        queryParams,
        router
    ]);
    if (loading) {
        return /*#__PURE__*/ _jsx(Result, {
            icon: /*#__PURE__*/ _jsx(Loading, {}),
            title: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "logging_in"
            }),
            subTitle: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "logging_in.subtitle"
            })
        });
    }
    if (error) {
        return /*#__PURE__*/ _jsx(Result, {
            status: "403",
            title: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "unauthorized"
            }),
            subTitle: /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "unauthorized.subtitle"
            })
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
